import {Component, EventEmitter, Output, ViewContainerRef} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Configuration} from '../../shared/services/configuration';
import {HttpClientCustom} from '../../shared/services/http.client';
import {Router} from '@angular/router';
import {SharedData} from '../../shared/sharedData';
import {ToasterComponent} from '../../toasterComponent/toasterComponent';

@Component({
    selector: 'child-operations',
    templateUrl: 'childOperations.html',
    inputs: ['childOperation'],
})
export class ChildOperationComponent {
    // tslint:disable-next-line:member-access
    public childOrgs;
    public _baseUrl: any;
    public showChild: boolean = false;
    public childOperation: any = [];
    @Output() selected = new EventEmitter();

    constructor(
        public _global: Configuration,
        public http: HttpClientCustom, public router: Router,
        public _toaster: ToasterComponent,
        public share: SharedData,
        public modalService: NgbModal,
        vcr: ViewContainerRef
    ) {
        this._baseUrl = _global.get("EPMS_BASE_URL");

    }

    select(e, i) {
        this.selected.emit(e);
    }

}



// WEBPACK FOOTER //
// ./src/app/tools/rolesAndPermission/childOperations.ts